var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.measured)?_c('div',{ref:"scrollDiv",staticClass:"scrollbar-measure"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }